import type { WorldMapCamera } from './WorldMapViewportController';

export function WorldMapNavigationControls(props: {
  camera: WorldMapCamera;
  canZoomIn: boolean;
  canZoomOut: boolean;
  canPanNorth: boolean;
  canPanEast: boolean;
  canPanSouth: boolean;
  canPanWest: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  onPanNorth: () => void;
  onPanEast: () => void;
  onPanSouth: () => void;
  onPanWest: () => void;
}): React.JSX.Element {
  return (
    <div className="world-map-navigation" aria-label="Map navigation controls">
      <div className="world-map-zoom-controls">
        <button type="button" title="Zoom in" aria-label="Zoom in" disabled={!props.canZoomIn} onClick={props.onZoomIn}>+</button>
        <output aria-label="Current map zoom">{formatZoom(props.camera.zoom)}</output>
        <button type="button" title="Zoom out" aria-label="Zoom out" disabled={!props.canZoomOut} onClick={props.onZoomOut}>−</button>
        <button type="button" title="Reset map view" aria-label="Reset map view" disabled={!props.canZoomOut} onClick={props.onReset}>⌂</button>
      </div>
      <div className="world-map-pan-controls" aria-label="Pan map">
        <span />
        <button type="button" title="Pan north" aria-label="Pan north" disabled={!props.canPanNorth} onClick={props.onPanNorth}>↑</button>
        <span />
        <button type="button" title="Pan west" aria-label="Pan west" disabled={!props.canPanWest} onClick={props.onPanWest}>←</button>
        <span className="world-map-pan-center" />
        <button type="button" title="Pan east" aria-label="Pan east" disabled={!props.canPanEast} onClick={props.onPanEast}>→</button>
        <span />
        <button type="button" title="Pan south" aria-label="Pan south" disabled={!props.canPanSouth} onClick={props.onPanSouth}>↓</button>
        <span />
      </div>
    </div>
  );
}

function formatZoom(zoom: number): string {
  return `${zoom.toFixed(zoom < 2 ? 1 : 0)}×`;
}
